import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { MerchantService, ConfigService, SignalrService, AppDataService } from 'app/services';
import { MerchantStatusEnum, MenuPermissionActionEnum } from 'app/models';
import { Utils } from 'app/utils';
import { MerchantTypeEnum } from '../../../../models/enums/lokal/merchant-type.enum';
import { ChatMessageTypeEnum } from 'app/models';
import { Observable, Subscription } from 'rxjs';
import { MenuHomeEnum } from 'app/home';
import { AppComponent } from 'app/app.component';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';
import { MartOnboardingDto } from '../mart-onboarding/interfaces/mart-onboarding-dto';

enum PartnerOnBoardingTab {
    AllPartners = 0,
    OnBoarding = 1
}

@Component({
    selector: 'mart-onboarding',
    templateUrl: './mart-onboarding.component.html',
    styleUrls: ['./mart-onboarding.component.scss'],
    providers: [MessageService]
})

export class MartOnboardingComponent implements OnInit, OnDestroy {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    set _menuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
        this.setOnboardingTitle(value);
        if (!this.lazyLoadHandled) {
            this.handleLazyLoad({
                first: 0,
                rows: this.rowsPerPage
            });
        }
    }
    private lazyLoadHandled = true;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public tableName: string = 'Mart Onboarding';
    public menuHomeEnum = MenuHomeEnum;
    public menuHomeEnumActive!: MenuHomeEnum;

    public chatMessageTypeEnum = ChatMessageTypeEnum;

    public merchants: Array<any> = [];

    public partnerActiveTab: PartnerOnBoardingTab = PartnerOnBoardingTab.AllPartners;

    public menuItems: MenuItem[] = [
        {
            label: 'All Partners',
            command: (e: any) => this.handleTabChange(PartnerOnBoardingTab.AllPartners)
        },
        {
            label: 'Onboarding',
            command: (e: any) => this.handleTabChange(PartnerOnBoardingTab.OnBoarding)
        }
    ];

    public cols: any[] = [
        { field: 'Id', header: 'Partner ID', width: '90px', active: false },
        { field: 'PartnerName', header: 'Partner Name', active: false },
        { field: 'XpressAgent', header: 'Xpress Agent', active: false },
        { field: 'CreatedAt', header: 'Created', width: '200px', active: false },
        { field: 'ExpiryAt', header: 'Expiry', width: '200px', active: false },
        { field: 'StatusText', header: 'Stage', width: '200px', active: false },
        { field: 'LastActive', header: 'Last Active', width: '200px', active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    public loading: boolean = true;

    private searchTimer: number = 0;

    //------------Create mart partner sidebar---------------------
    public showCreateMartPartnerSideBar: boolean = false;
    //------------End---------------------------------------------

    //------------Detail mart partner sidebar---------------------
    public showDetailMartPartnerSideBar: boolean = false;
    public merchantId: number = 0;
    //------------End---------------------------------------------
    //------------Approve merchant docs---------------------------
    public showApproveMartPartner: boolean = false;
    public selectedMerchant: any;
    //------------End---------------------------------------------

    //------------Review partner info sidebar---------------------
    public showReviewPartnerInfoSideBar: boolean = false;
    //------------End---------------------------------------------

    //------------suspend partner popup---------------------
    public showSuspendPartnerPopup: boolean = false;
    //------------End---------------------------------------------

    //------------Chat sidebar---------------------
    public chatId: number = 0;
    public showChatSideBar: boolean = false;
    //------------End---------------------------------------------
    public showCreateMartSideBar: boolean = false;

    $onboardingMerchants: Observable<any>;
    $onboardingMerchantsSubject: Subscription | undefined;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Merchants' },
        { label: this.app.backOfficeRoot.getMenuValue() }];

    constructor(
        private messageService: MessageService,
        private merchantService: MerchantService,
        public configService: ConfigService,
        public app: AppComponent,
        public appData: AppDataService,
        private signalRService: SignalrService) {
        this.handleApproveDocsPopupHide = this.handleApproveDocsPopupHide.bind(this);
        this.$onboardingMerchants = this.signalRService.OnboardingMerchantsObservable;
    }

    ngOnInit(): void {
        this.signalRService.startConnection().then(() => {
            console.log('signalR Service: connected');
            this.signalRService.addOnboardingMerchantsListener();
            this.$onboardingMerchantsSubject = this.$onboardingMerchants.subscribe((data: any) => {
                this.getMerchants(0);
                console.log('SignalR Service: updated onboarding merchants');
            });
        });
    }

    ngOnDestroy(): void {
        this.signalRService?.disconnect();
        this.$onboardingMerchantsSubject?.unsubscribe();
    }

    updateBreadcrumbs() {
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Merchants' },
            { label: this.app.backOfficeRoot.getMenuValue() }];
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getMerchants(skip);
        this.updateBreadcrumbs();
        this.lazyLoadHandled = false;
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }
    changedShowCreateMartSideBarEmit(value: any) {
        this.showCreateMartSideBar = value;
    }

    public getMerchants(skip: number): void {
        this.loading = true;

        const dto: MartOnboardingDto =  {
            SearchName: this.filter.searchName,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            MerchantType: this.menuHomeEnumActive === MenuHomeEnum.FoodOnboarding ? MerchantTypeEnum.Eats : MerchantTypeEnum.Marts,
            IsAllPartners: this.partnerActiveTab === PartnerOnBoardingTab.AllPartners ? true : false
        };
        this.merchantService.getMerchants(dto, this.menuHomeEnumActive, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.merchants = data.Items;

                this.merchants.forEach(item => {
                    item.CreatedAt = Utils.utcToLocaleString(item.CreatedAt);
                    item.ExpiryAt = Utils.utcToLocaleString(item.ExpiryAt);
                });

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchants(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public openCreateMartPartnerSideBar() {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create)){
            this.showCreateMartPartnerSideBar = !this.showCreateMartPartnerSideBar;
            this.showCreateMartSideBar = true;
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }
    changedShowCreateMartPartnerSideBarEmit(value: any) {
        this.showCreateMartPartnerSideBar = value;
        this.showCreateMartSideBar = value;
    }

    public openDetailMartPartnerSideBar(merchant: any) {
        this.merchantId = merchant.Id;
        switch (merchant.Status)
        {
            case MerchantStatusEnum.ForApproval:
                this.showApproveMartPartner = !this.showApproveMartPartner;
                this.selectedMerchant = merchant;
                break;
            case MerchantStatusEnum.FinalReview:
                this.openReviewPartnerInfoSideBar();
                break;
            case MerchantStatusEnum.OnGoingFinalReview:
                //TODO: Store Onboarding Admin Final Approval Page
                break;
            default:
                this.showDetailMartPartnerSideBar = !this.showDetailMartPartnerSideBar;
        }
    }

    changedShowDetailMartPartnerSideBarEmit(value: any) {
        this.showDetailMartPartnerSideBar = value;
    }

    public handleApproveDocsPopupHide() {
        this.showApproveMartPartner = false;
        this.getMerchants(0);
    }

    public openReviewPartnerInfoSideBar() {
        this.showReviewPartnerInfoSideBar = !this.showReviewPartnerInfoSideBar;
    }
    changedShowReviewPartnerInfoSideBarEmit(value: any) {
        this.showReviewPartnerInfoSideBar = value;
    }

    public openSuspendPartnerPopup(merchant: any) {
        this.selectedMerchant = merchant;
        this.showSuspendPartnerPopup = true;
    }

    changedDisplayModalSuspendEmit(value: any) {
        this.showSuspendPartnerPopup = value;
    }

    public openChatSideBar(merchant: any) {
        this.merchantId = merchant.Id;
        this.chatId = merchant.ChatId;
        this.showChatSideBar = !this.showChatSideBar;
    }
    changedShowChatSideBarEmit(value: any) {
        const findMerchant = this.merchants.find(f => f.Id === this.merchantId);
        if (findMerchant != null) {
            findMerchant.ChatIsReaded = true;
        }
        this.showChatSideBar = value;
    }
    public setOnboardingTitle(value: MenuHomeEnum) {
            switch (value) {
                case MenuHomeEnum.FoodOnboarding:
                    this.tableName = 'Eats All Partners';
                    break;
                case MenuHomeEnum.MartOnboarding:
                    this.tableName = 'Mart All Partners';
                    break;
                default:
                    this.tableName = 'Onboarding';
                    break;
            }
    }

    handleTabChange(value: PartnerOnBoardingTab) {
        this.partnerActiveTab = value;
        this.getMerchants(0);
    }
}
